var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 562,
    viewBox: "0 0 305 562",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_821_14411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.739 283.107L181.484 350.099H123.994L152.739 283.107Z",
    fill: "url(#paint0_linear_821_14411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.564 319.033L173.117 345.97L213.769 386.837L240.564 319.033Z",
    fill: "url(#paint1_linear_821_14411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.739 531.568L181.484 464.576H123.994L152.739 531.568Z",
    fill: "url(#paint2_linear_821_14411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.517 493.07L211.722 425.266L171.07 466.132L238.517 493.07Z",
    fill: "url(#paint3_linear_821_14411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.781 405.791L208.142 376.893V434.688L274.781 405.791Z",
    fill: "url(#paint4_linear_821_14411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4215 493.07L133.868 466.133L93.2165 425.266L66.4215 493.07Z",
    fill: "url(#paint5_linear_821_14411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6902 405.798L97.329 434.695L97.329 376.901L30.6902 405.798Z",
    fill: "url(#paint6_linear_821_14411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4215 319.023L93.2165 386.827L133.868 345.96L66.4215 319.023Z",
    fill: "url(#paint7_linear_821_14411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.083 337.458L152.614 337.458L181.144 337.458L221.493 378.02L221.493 406.702L221.493 435.383L181.144 475.946L152.614 475.946L124.083 475.946L83.7353 435.383L83.7353 406.702L83.7353 378.02L124.083 337.458Z",
    fill: "#F6E4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.083 337.458L152.614 337.458L181.144 337.458L221.493 378.02L221.493 406.702L221.493 435.383L181.144 475.946L152.614 475.946L124.083 475.946L83.7353 435.383L83.7353 406.702L83.7353 378.02L124.083 337.458Z",
    fill: "url(#paint8_radial_821_14411)",
    fillOpacity: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153 285.183L153.013 0",
    stroke: "#EBC644"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_821_14411",
    x: 0.690186,
    y: 253.107,
    width: 304.09,
    height: 308.46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.966667 0 0 0 0 0.893119 0 0 0 0 0.632361 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_821_14411"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_821_14411",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_821_14411",
    x1: 152.739,
    y1: 283.107,
    x2: 152.739,
    y2: 372.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#EBC644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_821_14411",
    x1: 240.564,
    y1: 319.033,
    x2: 177.404,
    y2: 381.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#EBC644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_821_14411",
    x1: 152.739,
    y1: 531.568,
    x2: 152.739,
    y2: 442.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#EBC644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_821_14411",
    x1: 238.517,
    y1: 493.07,
    x2: 175.357,
    y2: 430.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#EBC644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_821_14411",
    x1: 274.781,
    y1: 405.791,
    x2: 185.929,
    y2: 405.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#EBC644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_821_14411",
    x1: 66.4215,
    y1: 493.07,
    x2: 129.581,
    y2: 430.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#EBC644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_821_14411",
    x1: 30.6902,
    y1: 405.798,
    x2: 119.542,
    y2: 405.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#EBC644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_821_14411",
    x1: 66.4215,
    y1: 319.023,
    x2: 129.581,
    y2: 381.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#EBC644"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_821_14411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.614 406.702) rotate(67.6069) scale(74.8912 74.6112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E4A1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.29aa1f540b9d3c4e21b8558a42b034e8.svg";
export { ForwardRef as ReactComponent };